/*
 * @Author: nsj
 * @Date: 2021-03-02 13:42:44
 * @Description: description
 */
import Vue from 'vue'
import App from './App.vue'
export const eventBus = new Vue()
import router from './routers/index.js'
import store from './store'
import 'view-design/dist/styles/iview.css'
import echarts from 'echarts'
import Viewer from 'v-viewer'
Vue.use(Viewer)
import 'viewerjs/dist/viewer.css'
import { Message, Notice,Modal } from 'view-design'
Vue.prototype.$echarts = echarts

Vue.prototype.$Message = Message
Vue.prototype.$Notice = Notice
Vue.prototype.$Modal = Modal

Vue.config.productionTip = false
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
